import React, { useState } from 'react';
import pdf from '../assets/resume_updated.pdf'
import { Document, Page } from 'react-pdf'

function Resume(props) {
    const [numPages, setNumPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
  
    function onDocumentLoadSuccess( numPages ){
      setNumPages(numPages);
    }
    return (
        <div className='comming'>
          
            <embed src={pdf} type="application/pdf" width="100%" height="100%" />
        </div>
    );
}

export default Resume;